import Img1 from "../../../../../images/other/control_step1.png";

import { Button } from "primereact/button";

export default function ModuleControlStep1(props) {
  const { onTabChange } = props;

  return (
    <>
      <div className="text-xl line-height-4 bg-yellow-100 border-1 border-400 border-round-md px-3 py-2 mb-4">
        當您的小孩被診斷為近視後，視力逐漸惡化，看不清楚黑板，您的小孩該配戴哪一種眼鏡?本工具將幫助您了解配鏡選擇有哪些，藉以幫助您選擇合適的眼鏡來輔助藥物控制近視。
      </div>

      <div className="text-2xl font-bold mb-2">適用對象 / 適用狀況</div>
      <div className="text-xl">
        確診為近視，未矯正視力未達 0.9 的孩童，年齡介於6至12歲國小之家長。
      </div>

      <div className="text-4xl text-main font-bold text-center text-shadow-1 mt-6">
        目前用來作為近視控制的光學矯正的方法
      </div>
      <div className="text-4xl font-bold text-center mt-2">周邊離焦原理</div>
      <div className="flex flex-column lg:flex-row lg:justify-content-center align-items-center lg:align-items-start mt-3">
        <div className="w-11 lg:w-6 lg:mr-3 flex-order-1 lgflex-order-0">
          <img className="w-full" src={Img1} alt="周邊離焦原理" />
          <div className="line-height-3">
            <div>
              A：未矯正之近視眼(中央影像落在視網膜前方，周邊影像落在視網膜 後方)
              →視力不清晰
            </div>
            <div>
              B：周邊影像落在視網膜後方 →周邊遠視性離焦影像落在視網膜
              後方→誘發眼軸增長
            </div>
            <div>
              C：周邊離焦眼鏡--周邊影像落在視網膜 前方 →
              周邊近視性離焦→抑制眼軸增長
            </div>
          </div>
        </div>
        <div className="flex justify-content-center w-full lg:w-5 flex-order-0 lg:flex-order-1">
          <div className="flex flex-column lg:flex-row align-items-center mt-2 lg:mt-4 mb-2 lg:mb-0">
            <div
              className="border-solid flex-shrink-0 hidden lg:block"
              style={{
                borderWidth: "1rem 1.5rem 1rem 0",
                borderColor:
                  "transparent var(--blue-100) transparent transparent",
              }}
            ></div>
            <div
              className="border-solid flex-shrink-0 block lg:hidden flex-order-1 lg:flex-order-0"
              style={{
                borderWidth: "1.5rem 1rem 0 1rem",
                borderColor:
                  "var(--blue-100) transparent transparent transparent",
              }}
            ></div>
            <div className="w-full sm:w-8 lg:w-full text-xl border-1 border-blue-100 border-round-md p-3 flex-order-0 lg:flex-order-1">
              眼睛的周邊視網膜受到的光焦點位置可以影響眼球的生長。當眼球的前部（即水晶體和角膜）把光聚焦到視網膜的後面時，稱為“周邊遠視距離離焦”。周邊遠視距離離焦會促使眼球變長，近視進展較快。
            </div>
          </div>
        </div>
      </div>

      <div className="mt-6">
        <div className="w-full md:w-7 lg:w-6 mx-auto">
          <div className="text-2xl font-bold text-center mb-2">
            多焦眼鏡(multifocal spectacle lenses)
          </div>
          <div className="text-lg border-1 border-400 border-round-md p-3">
            特殊的眼鏡鏡片設計，其在鏡片表面上具有逐漸變化的屈光度數，以便為調節能力下降的患者在不同的觀看距離上提供清晰的視力。
          </div>
        </div>
      </div>
      <div className="border-1 border-400 border-round-md mt-3 p-2">
        <div className="w-full text-2xl font-bold text-center mb-2">
          周邊離焦原理
        </div>
        <div className="flex flex-column md:flex-row">
          <div className="w-12 md:w-4 border-1 border-400 border-round-md p-3">
            <div className="text-2xl font-bold text-center mb-3">
              <span className="text-white bg-main-d border-round-md px-2 py-1">
                角膜塑型片
              </span>
            </div>
            <div className="text-lg line-height-3">
              利用夜間睡眠時配戴6~10
              小時，鏡片會壓迫角膜上皮，使上皮細胞變薄並重新排列，促使中間角膜變平而週邊變陡，形成周邊離焦效果。
            </div>
          </div>
          <div className="w-12 md:w-4 border-1 border-400 border-round-md p-3 mt-2 md:mt-0 md:ml-2">
            <div className="text-2xl font-bold text-center mb-3">
              <span className="text-white bg-main-d border-round-md px-2 py-1">
                兒控日拋隱形眼鏡
              </span>
            </div>
            <div className="text-lg line-height-3">
              透過專利技術，製造近視控制區(周邊離焦作用)與近視矯正視力區(提供清晰視力)。
            </div>
          </div>
          <div className="w-12 md:w-4 border-1 border-400 border-round-md p-3 mt-2 md:mt-0 md:ml-2">
            <div className="text-2xl font-bold text-center mb-3">
              <span className="text-white bg-main-d border-round-md px-2 py-1">
                近視控制框架鏡片-DIMS
              </span>
            </div>
            <div className="text-lg line-height-3">
              特殊眼鏡組成，包括一個用來矯正屈光不正的「中心光學區」，及數百個圍繞中心區伸延至鏡片周邊的「近視離焦」。
              可以有清楚視力與控制近視。
            </div>
          </div>
        </div>
      </div>

      <div
        className="text-4xl text-main font-bold text-center text-shadow-2 mt-6"
        content="光學原理近視控制的效果"
      >
        光學原理近視控制的效果
      </div>
      <div className="relative flex flex-column align-items-center pt-3">
        <div className="absolute w-full md:w-10 lg:w-8 h-full -mx-2 md:mx-0">
          <div className="w-full h-full imgClip"></div>
        </div>
        <div className="flex flex-column md:flex-row w-full md:w-9 lg:w-7 pt-4 md:pt-3">
          <div
            className="relative w-full md:w-6 min-h-12rem border-1 border-400 border-round-md p-3 mt-5"
            style={{ backgroundColor: "#ed7d31" }}
          >
            <div className="absolute top-0 left-0 w-full text-2xl font-bold text-center -mt-4">
              <div className="inline-block text-white bg-main border-round-md px-3 py-1">
                角膜塑型片
              </div>
            </div>
            <div className="text-lg text-white line-height-3 pt-3">
              <div className="text-center">
                <div className="inline-block border-bottom-1 mb-2">
                  多項隨機試驗研究統合報告
                </div>
                <div>眼軸：每年延緩增加0.16 mm</div>
              </div>
            </div>
          </div>
          <div
            className="relative w-full md:w-6 min-h-12rem border-1 border-400 border-round-md p-3 mt-5 md:ml-2"
            style={{ backgroundColor: "#d17b5c" }}
          >
            <div className="absolute top-0 left-0 w-full text-2xl font-bold text-center -mt-4">
              <div className="inline-block text-white bg-main border-round-md px-3 py-1">
                日拋兒控隱形眼鏡
              </div>
            </div>
            <div className="text-lg text-white line-height-3 pt-3">
              <div className="text-center mb-2">
                <div className="inline-block border-bottom-1">
                  三年的隨機試驗研究
                </div>
              </div>
              <div className="mb-2">
                度數：相對於對照組三年延緩72度的度數增加。
              </div>
              <div>眼軸：相對於對照組三年延緩0.32mm的眼軸增加。</div>
            </div>
          </div>
        </div>
        <div className="flex flex-column md:flex-row w-full md:w-9 lg:w-7 pb-5">
          <div
            className="relative w-full md:w-6 min-h-12rem border-1 border-400 border-round-md p-3 mt-5"
            style={{ backgroundColor: "#b98a82" }}
          >
            <div className="absolute top-0 left-0 w-full text-2xl font-bold text-center -mt-4">
              <div className="inline-block text-white bg-main border-round-md px-3 py-1">
                多焦點眼鏡
              </div>
            </div>
            <div className="text-lg text-white line-height-3 pt-3">
              <div className="mb-2">
                眼軸：相對於單焦眼鏡兩年延緩0.11mm的眼軸增加。
              </div>
              <div>度數：相對於單焦眼鏡一年延緩0.20D (20度)度數增加。</div>
            </div>
          </div>
          <div
            className="relative w-full md:w-6 min-h-12rem border-1 border-400 border-round-md p-3 mt-5 md:ml-2"
            style={{ backgroundColor: "#a5a5a5" }}
          >
            <div className="absolute top-0 left-0 w-full text-2xl font-bold text-center -mt-4">
              <div className="inline-block text-white bg-main border-round-md px-3 py-1">
                周邊離焦鏡框
              </div>
            </div>
            <div className="text-lg text-white line-height-3 pt-3">
              <div className="mb-2">
                度數：相對於對照組兩年延緩44度的度數增加。
              </div>
              <div>眼軸：相對於對照組兩年延緩0.34mm的眼軸增加。</div>
            </div>
          </div>
        </div>
      </div>

      <div
        className="text-4xl text-main font-bold text-center text-shadow-2 mt-6 mb-2"
        content="光學近視控制的注意事項"
      >
        光學近視控制的注意事項
      </div>
      <div className="flex flex-column md:flex-row">
        <div className="w-12 md:w-4 bg-fifth border-1 border-400 border-round-md p-3 md:ml-2">
          <div className="text-2xl font-bold text-center mb-3">
            多焦點眼鏡
            <br />
            兒控近視框架眼鏡
          </div>
          <div className="text-lg line-height-3">
            <div className="text-white bg-main border-1 border-400 border-round-md p-3">
              初期需適應鏡片焦距
            </div>
          </div>
        </div>
        <div className="w-12 md:w-4 bg-fifth border-1 border-400 border-round-md p-3 mt-2 md:mt-0 md:ml-2">
          <div className="text-2xl font-bold text-center mb-3">
            兒控日拋隱形眼鏡
          </div>
          <div className="text-lg line-height-3">
            <div className="text-white bg-gray-500 border-1 border-400 border-round-md p-3">
              睡眠仍需足夠，避免眼睛過乾不適用
            </div>
            <div className="text-white bg-gray-500 border-1 border-400 border-round-md p-3 mt-2">
              存在一定的感染或過敏風險
            </div>
            <div className="text-white bg-gray-500 border-1 border-400 border-round-md p-3 mt-2">
              長時間配戴可能導致乾眼、<span className="text-900">缺氧</span>
            </div>
          </div>
        </div>
        <div className="w-12 md:w-4 bg-fifth border-1 border-400 border-round-md p-3 mt-2 md:mt-0 md:ml-2">
          <div className="text-2xl font-bold text-center mb-3">角膜塑型片</div>
          <div className="text-xl font-bold text-center mb-2">
            常因不正當清洗導致
          </div>
          <div className="text-lg line-height-3">
            <div className="text-white bg-orange-400 border-1 border-400 border-round-md p-3">
              微生物角膜炎，綠膿桿菌與阿米巴原蟲感染占比例最高
            </div>
            <div className="text-white bg-orange-400 border-1 border-400 border-round-md p-3 mt-2">
              按照原廠建議清潔，切勿使用自來水清洗鏡片
            </div>
            <div className="text-white bg-orange-400 border-1 border-400 border-round-md p-3 mt-2">
              父母需要負擔確認配戴、清洗與不適及時就醫之責任
            </div>
          </div>
        </div>
      </div>

      <div className="text-center my-3">
        <Button
          className="p-button-warning text-white px-3 rotate-icon-xy-180 rotate-icon-y-180"
          type="button"
          label="下一步：比較"
          icon="fa fa-reply bg-main border-round-md p-1"
          onClick={() => onTabChange({ index: 1 })}
        />
      </div>
    </>
  );
}
